import { gql } from '__generated__';

export default gql(`
  mutation AssignTicketNumbers($input: AssignTicketNumbersInput!) {
    assignTicketNumbers(input: $input) {
      id
      assigning_ticket_numbers
      missing_ticket_number_count
      assigned_ticket_number_count
    }
  }
`);
